import remarkGfm from 'remark-gfm'

import type { Components } from 'react-markdown'
import Markdown from 'react-markdown'

const markdownComponents: Components = {
  a: ({ children, ...props }) => (
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-600 underline hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
      {...props}
    >
      {children}
    </a>
  ),
  h2: ({ children }) => (
    <h2 className="mb-3 mt-6 border-b pb-1 text-base font-semibold">{children}</h2>
  ),
  h3: ({ children }) => <h3 className="mb-2 mt-5 text-sm font-semibold">{children}</h3>,
  pre: ({ children }) => <pre className="overflow-x-auto rounded-md p-3">{children}</pre>,
  code: ({ children, className }) => {
    const isInline = !className
    if (isInline) {
      return <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-sm">{children}</code>
    }
    return <code className={className}>{children}</code>
  },
}

interface MarkdownRendererProps {
  content: string
}

export default function MarkdownRenderer({ content }: MarkdownRendererProps) {
  return (
    <div className="prose prose-sm max-w-none dark:prose-invert prose-p:my-4 prose-p:leading-relaxed prose-headings:mt-6 prose-headings:mb-3 prose-headings:font-semibold prose-li:my-1 prose-hr:my-6 prose-pre:bg-muted prose-pre:text-foreground">
      <Markdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
        {content}
      </Markdown>
    </div>
  )
}
